import { Box, makeStyles, Typography } from "@material-ui/core";
import React from "react";
import { useSelector } from "react-redux";
import Tilt from "react-tilt";
import PBWhite from "../../../assets/svgs/pb_white_icon.svg";

function TransperantCard({ icon, text, info, list, extra, title }) {
  /* use commented code while integration */
  const state = useSelector((state) => state.sliderDataReducer.prices);
  // console.log(state);
  // const state = useSelector((state) => state.tradingFee);
  const classes = useStyles();
  return (
    <div
      onClick={() => {
        title == "For 24/7 Assistance" && window.fcWidget.open();
      }}
      className={`${classes.root} md:min-h-[298px] md:max-w-[320px]  w-[90%] `}
    >
      <div
        style={{ borderBottom: "1px solid rgba(96, 96, 96, 0.3)" }}
        className="w-full mb-3"
      >
        <h3 className="pt-4 pb-4 font-semibold">{title}</h3>
      </div>

      {!list ? (
        <>
          <img src={icon} alt="" className={classes.image} />
          <Typography variant="h4">{text}</Typography>
          {info ? (
            <Typography variant="p" style={{ fontWeight: 100 }}>
              {info}
            </Typography>
          ) : null}
          {extra ? (
            <Typography variant="p" style={{ fontWeight: 100 }}>
              {extra}
            </Typography>
          ) : null}
        </>
      ) : (
        <>
          <Box
            display="flex"
            className={`${classes.listBox} mb-3`}
            flexDirection="column"
            flexWrap="wrap"
            justifyContent="space-between"
            alignItems="center"
          >
            {" "}
            <div className="flex justify-between w-full text-xs opacity-30 mt-2">
              <p>Exchange</p>
              <p>Monthly Fees</p>
            </div>
            {state.map((item, index) => (
              <>
                <Box
                  key={index}
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  textAlign="center"
                  className={`${classes.innerBox} py-3`}
                >
                  <Typography
                    className={`${classes.typographyWidth} text-left  font-normal`}
                    variant="subtitle1"
                  >
                    {item.name}
                  </Typography>
                  <Typography
                    className={`${classes.typographyWidth} text-right font-normal`}
                    variant="subtitle1"
                  >
                    ₹{item.value}
                  </Typography>
                </Box>
              </>
            ))}
          </Box>

          <div
            className="flex justify-evenly w-full pt-8 pb-5 text-center "
            style={{
              borderTop: "1px solid rgba(96, 96, 96, 0.3)",
            }}
          >
            <div className="flex flex-col items-start">
              <img src={PBWhite} width={30}></img>
              <h2 className="w-1/2 text-left">Pocketbits</h2>
            </div>
            <Typography
              className={`${classes.typographyWidth} text-right `}
              variant="subtitle1"
            >
              <strong className={` bg-pb-primary-100 p-3 text-2xl rounded-md `}>
                ₹0
              </strong>
            </Typography>
          </div>
        </>
      )}
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "10px 30px",
    textAlign: "center",
    marginTop: "20px",

    display: "flex",

    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    // left: "560px",
    // top: "1241px",
    color: "#fff",
    background:
      "linear-gradient(180deg, rgba(44, 48, 56, 0) 75.43%, rgba(89, 209, 158, 0.5) 100%), radial-gradient(98.09% 98.09% at 31.51% 23.05%, rgba(75, 80, 94, 0.7) 0%, rgba(36, 38, 43, 0.7) 100%)",
    // boxShadow: "37.9444px 56.9167px 189.722px rgba(16, 18, 26, 0.5)",
    // backdropFilter: "blur(7.58889px)",

    borderRadius: "24px",
    backdropFilter: "blur(10px)",
    WebkitBackdropFilter: "blur(10px)",

    transition: "all .4s ease-in-out",
    "&:hover": {
      [theme.breakpoints.down("sm")]: {
        transform: "scale(1.05,1.05)",
      },
      transform: "scale(1.05,1.05)",
    },
  },
  image: {
    marginBottom: "10px",
  },
  listBox: {
    height: "100%",
    width: "100%",
  },
  innerBox: {
    width: "100%",
  },
  pocketBits: {
    // borderTop: "1px solid rgba(96, 96, 96, 0.9)",
  },
  typographyWidth: {
    width: "50%",
  },
}));
export default TransperantCard;
